<template>
  <div>
    <form-accordion :title="$t('account_tb.test_validation')" :isTitleUpperCase="false">
      <b-button-group class="mt-3 mt-sm-0" style="display:grid;grid-auto-flow:column;">
        <b-button
            class="responsive-button"
            v-for="(tab, index) in tabs"
            :key="index"
            :variant="tabName === index ? 'primary' : 'secondary'"
            @click="tabName = index">
          {{ $t(tab.translationKey) }}
        </b-button>
      </b-button-group>

      <b-tabs v-model="tabName" @input="onTabChange" nav-class="d-none">
        <b-tab :title="$t('account_tb.all')">
          <b-row class="justify-content-center mt-5">
            <spinner v-if="activateSpinnerTest"></spinner>
            <b-col v-else-if="pieChartDataAll" cols="12">
              <h3 class="text-center">
                {{ $t("account_tb.all") }}
              </h3>
              <figure role="group" :aria-labelledby="'chart-title-all-' + _uid">
                <figcaption :id="'chart-title-all-' + _uid" class="sr-only">
                  {{ $t('monitoring.chart_status_distribution_title') }}
                </figcaption>
                
                <div :aria-hidden="true">
                  <pie-chart
                      id="myPieChart"
                      ref="pieChartAll"
                      :chart-data="pieChartDataAll"
                      :options="chartOptionsAll">
                  </pie-chart>
                </div>
                
                <table class="sr-only" :aria-label="$t('monitoring.chart_data_table_label')">
                  <caption>{{ $t('monitoring.chart_status_distribution_detail') }}</caption>
                  <thead>
                    <tr>
                      <th scope="col">{{ $t('monitoring.status_label') }}</th>
                      <th scope="col">{{ $t('monitoring.count_label') }}</th>
                      <th scope="col">{{ $t('monitoring.percentage_label') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="pieChartDataAll" v-for="(value, index) in pieChartDataAll.datasets[0].data" :key="index">
                      <th scope="row">{{ pieChartDataAll.labels[index] }}</th>
                      <td>{{ value }}</td>
                      <td>{{ getPercentage(value, 'all') }}%</td>
                    </tr>
                  </tbody>
                </table>
              </figure>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('account_tb.responder')">
          <b-row class="justify-content-center mt-5">
            <spinner v-if="activateSpinnerTest"></spinner>
            <b-col v-else-if="pieChartDataRes" cols="12">
              <h3 class="text-center">
                {{ $t("account_tb.responder") }}
              </h3>
              <figure role="group" :aria-labelledby="'chart-title-res-' + _uid">
                <figcaption :id="'chart-title-res-' + _uid" class="sr-only">
                  {{ $t('monitoring.chart_status_distribution_title') }} - {{ $t("account_tb.responder") }}
                </figcaption>
                
                <div :aria-hidden="true">
                  <pie-chart
                      ref="pieChartRes"
                      :chart-data="pieChartDataRes"
                      :options="chartOptionsRes">
                  </pie-chart>
                </div>
                
                <table class="sr-only" :aria-label="$t('monitoring.chart_data_table_label')">
                  <caption>{{ $t('monitoring.chart_status_distribution_detail') }} - {{ $t("account_tb.responder") }}</caption>
                  <thead>
                    <tr>
                      <th scope="col">{{ $t('monitoring.status_label') }}</th>
                      <th scope="col">{{ $t('monitoring.count_label') }}</th>
                      <th scope="col">{{ $t('monitoring.percentage_label') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="pieChartDataRes" v-for="(value, index) in pieChartDataRes.datasets[0].data" :key="index">
                      <th scope="row">{{ pieChartDataRes.labels[index] }}</th>
                      <td>{{ value }}</td>
                      <td>{{ getPercentage(value, 'resp') }}%</td>
                    </tr>
                  </tbody>
                </table>
              </figure>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('account_tb.requester')">
          <b-row class="justify-content-center mt-5">
            <spinner v-if="activateSpinnerTest"></spinner>
            <b-col v-else-if="pieChartDataReq" cols="12">
              <h3 class="text-center">
                {{ $t("account_tb.requester") }}
              </h3>
              <figure role="group" :aria-labelledby="'chart-title-req-' + _uid">
                <figcaption :id="'chart-title-req-' + _uid" class="sr-only">
                  {{ $t('monitoring.chart_status_distribution_title') }} - {{ $t("account_tb.requester") }}
                </figcaption>
                
                <div :aria-hidden="true">
                  <pie-chart
                      ref="pieChartReq"
                      :chart-data="pieChartDataReq"
                      :options="chartOptionsReq">
                  </pie-chart>
                </div>
                
                <table class="sr-only" :aria-label="$t('monitoring.chart_data_table_label')">
                  <caption>{{ $t('monitoring.chart_status_distribution_detail') }} - {{ $t("account_tb.requester") }}</caption>
                  <thead>
                    <tr>
                      <th scope="col">{{ $t('monitoring.status_label') }}</th>
                      <th scope="col">{{ $t('monitoring.count_label') }}</th>
                      <th scope="col">{{ $t('monitoring.percentage_label') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="pieChartDataReq" v-for="(value, index) in pieChartDataReq.datasets[0].data" :key="index">
                      <th scope="row">{{ pieChartDataReq.labels[index] }}</th>
                      <td>{{ value }}</td>
                      <td>{{ getPercentage(value, 'req') }}%</td>
                    </tr>
                  </tbody>
                </table>
              </figure>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </form-accordion>
  </div>
</template>

<script>
import {Pie} from "vue-chartjs"
import ChartDataLabels from "chartjs-plugin-datalabels"
import spinner from "@/components/common/spinner.vue"
import FormAccordion from "@/components/common/FormAccordion.vue"


export default {
  name: 'ChartPieStat',
  components: {
    FormAccordion,
    spinner,
    "pie-chart": {
      extends: Pie,
      props: ["chartData", "options"],
      mounted() {
        this.addPlugin(ChartDataLabels)
        this.renderChart(this.chartData, this.options)
      }
    }
  },
  props: {
    stat: {
    },
  },
  computed: {},
  data() {
    return {
      tabName: 0,
      activateSpinnerTest: false,
      tabs: [
        {translationKey: 'account_tb.all'},
        {translationKey: 'account_tb.responder'},
        {translationKey: 'account_tb.requester'},
      ],
      chartOptionsAll: {
        responsive: true,
        aspectRatio: 1,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      chartOptionsReq: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      chartOptionsRes: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      pieChartDataAll: null,
      pieChartDataRes: null,
      pieChartDataReq: null,

    }
  },
  created() {
  },
  mounted() {
    this.generatePieChartDataStatus(this.stat)
  },
  beforeDestroy() {
  },
  watch: {
    tabName(newVal) {
      this.$nextTick(() => {
        this.onTabChange(newVal)
      })
    }
  },
  methods: {
    onTabChange(index) {
      const charts = [
        {
          ref: this.$refs.pieChartAll,
          data: this.pieChartDataAll,
          options: this.chartOptionsAll
        },
        {
          ref: this.$refs.pieChartRes,
          data: this.pieChartDataRes,
          options: this.chartOptionsRes
        },
        {
          ref: this.$refs.pieChartReq,
          data: this.pieChartDataReq,
          options: this.chartOptionsReq
        },
      ]

      console.log(charts[index].data)

      const chart = charts[index]

      if (chart && chart.ref) {
        chart.ref.renderChart(chart.data, chart.options)
      }

      // Gérer le spinner si nécessaire
      // this.$nextTick(() => {
      //   this.activateSpinner = false
      // })
    },
    generatePieChartDataStatus(data) {
      let types = ['all', 'req', 'resp'];
      let pieChartData = {};

      types.forEach((type) => {
        let filteredResponses = data.filter((item) => {
          if (type === 'all') {
            return item.Type === 'resp' || item.Type === 'req';
          }
          return item.Type === type;
        });

        let statusCounts = {
          OK: 0,
          KO: 0,
          NULL: 0,
          RUN: 0,
          CONF_NOT_FOUND: 0,
        };

        filteredResponses.forEach((item) => {
          switch (item.Status) {
            case '2':
              statusCounts.OK++;
              break;
            case '0':
              statusCounts.KO++;
              break;
            case '1':
              if (type === 'req') statusCounts.RUN++;
              break;
            case '3':
              if (type === 'resp') statusCounts.CONF_NOT_FOUND++;
              break;
            default:
              statusCounts.NULL++;
              break;
          }
        });

        let labels = ['OK', 'KO', 'Null'];
        let dataValues = [statusCounts.OK, statusCounts.KO, statusCounts.NULL];
        let colors = [
          this.getCustomColor('OK', 0.8),
          this.getCustomColor('KO', 0.8),
          this.getCustomColor('NULL', 0.8),
        ];

        if (type === 'req') {
          labels.push('RUN');
          dataValues.push(statusCounts.RUN);
          colors.push(this.getCustomColor('RUN', 0.8));
        }

        if (type === 'resp') {
          labels.push('Conf introuvable');
          dataValues.push(statusCounts.CONF_NOT_FOUND);
          colors.push(this.getCustomColor('CONF_NOT_FOUND', 0.8));
        }

        pieChartData[type] = {
          labels: labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: colors,
            },
          ],
        };
      });

      this.pieChartDataAll = pieChartData['all'];
      this.pieChartDataReq = pieChartData['req'];
      this.pieChartDataRes = pieChartData['resp'];

      this.$nextTick(() => {
        if (this.$refs.pieChartAll) {
          this.$refs.pieChartAll.renderChart(
              this.pieChartDataAll,
              this.chartOptionsAll
          );
        }
        if (this.$refs.pieChartReq) {
          this.$refs.pieChartReq.renderChart(
              this.pieChartDataReq,
              this.chartOptionsReq
          );
        }
        if (this.$refs.pieChartRes) {
          this.$refs.pieChartRes.renderChart(
              this.pieChartDataRes,
              this.chartOptionsRes
          );
        }
      });
    },
    getCustomColor(key, alpha = 1) {
      let r, g, b
      // Suppression des couleurs aléatoires pour assurer des contrastes constants WCAG AA
      switch (key) {
        case 'InTesting': // Orange WCAG AA compatible
          r = 182;
          g = 112;
          b = 0;
          break;
        case 'RUN': // Violet WCAG AA compatible  
          r = 95;
          g = 39;
          b = 205;
          break;
        case 'OK': // Bleu WCAG AA compatible
          r = 0;
          g = 97;
          b = 161;
          break;
        case 'connector 3': // Gris WCAG AA compatible
        case 'NoEnrollment': // Gris WCAG AA compatible
          r = 108;
          g = 108;
          b = 108;
          break;
        case 'CONF_NOT_FOUND': // Vert WCAG AA compatible
          r = 0;
          g = 121;
          b = 89;
          break;
        case 'Planned': // Bleu profond WCAG AA compatible
          r = 0;
          g = 80;
          b = 132;
          break;
        case 'KO': // Brun WCAG AA compatible
          r = 166;
          g = 68;
          b = 0;
          break;
        case 'connector 7': // Cyan WCAG AA compatible
          r = 0;
          g = 130;
          b = 130;
          break;
        case 'AllTestOk': // Vert foncé WCAG AA compatible
          r = 0;
          g = 102;
          b = 41;
          break;
        case 'NULL': // Rouge WCAG AA compatible
          r = 153;
          g = 0;
          b = 0;
          break;
        default:
          // Couleur de fallback WCAG AA compatible
          r = 85;
          g = 85;
          b = 85;
          break;
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },
    
    // Nouvelle méthode pour calculer les pourcentages par type de graphique
    getPercentage(value, type) {
      let data = null
      switch (type) {
        case 'all':
          data = this.pieChartDataAll
          break
        case 'req':
          data = this.pieChartDataReq
          break
        case 'resp':
          data = this.pieChartDataRes
          break
        default:
          return 0
      }
      
      if (!data || !data.datasets[0]) return 0
      const total = data.datasets[0].data.reduce((a, b) => a + b, 0)
      if (total === 0 || value === 0) return 0
      return ((value / total) * 100).toFixed(1)
    }
  }
}
</script>

<style scoped>
/* Classe pour masquer visuellement mais garder accessible aux lecteurs d'écran */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Conteneur du graphique avec rôle d'image pour l'accessibilité */
.chart-container {
  position: relative;
}

/* Tableau de données accessible */
.chart-data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 0.9rem;
}

.chart-data-table th,
.chart-data-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.chart-data-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.chart-data-table caption {
  font-weight: bold;
  margin-bottom: 0.5rem;
  text-align: left;
  font-size: 1rem;
}

/* Indicateur visuel de couleur dans le tableau */
.status-indicator {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid #666;
}

/* Classes existantes mises à jour avec des couleurs WCAG AA */
.result-vignette {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  border: 1px solid #666;
}

.result-mtch {
  background-color: rgba(0, 102, 41, 0.8);
}

.result-nmtc {
  background-color: rgba(153, 0, 0, 0.8);
}

.result-cmtc {
  background-color: rgba(182, 112, 0, 0.8);
}

.result-noap {
  background-color: rgba(108, 108, 108, 0.8);
}
</style>
